<template>
  <modal-component
    label="Modificar celular"
    label-align="center"
    button-label="Listo"
    button-align="center"
    :show="show"
    :body-scroll="false"
    @close="onClose"
    @aceptar="onClose"
    analyticsName="Listo"
    :analyticsSubmodule="analyticsSubmodule"
  >
    <phone-number
      class="phone-number"
      :scroll-on-focus="false"
      v-model="value"
      :required="true"
      :analyticsSubmodule="analyticsSubmodule"
      :quantumObfuscate="quantumObfuscate"
    />
  </modal-component>
</template>

<script>
import PhoneNumber from "@/components/core/composite/PhoneNumber";
import ModalComponent from "@/components/core/ModalComponent";
export default {
  name: "ChangePhone",
  components: {
    PhoneNumber,
    ModalComponent
  },
  props: {
    value: Object,
    show: {
      type: Boolean,
      default: false
    },
    analyticsSubmodule: {
      type: String,
      default: null
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClose() {
      const celular = this?.value?.normalizado;
      if (celular && celular.area && celular.caracteristica && celular.nro) {
        this.$emit("close");
      }
    }
  }
};
</script>

<style scoped>
.phone-number {
  padding-bottom: 20px;
  padding-top: 10px;
}
</style>
